import React from 'react';
import Card from './Card';

interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  minDate?: string;
  maxDate?: string;
  className?: string;
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  minDate,
  maxDate,
  className = ''
}) => {
  return (
    <Card className={className}>
      <Card.Body>
        <div className="flex gap-4 items-center flex-wrap">
          <div className="mb-0 flex-1 min-w-[200px]">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Start Date
            </label>
            <input
              type="date"
              className="w-full p-2.5 text-sm text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md transition-all focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20"
              value={startDate}
              onChange={(e) => onStartDateChange(e.target.value)}
              min={minDate}
              max={maxDate}
            />
          </div>
          <div className="mb-0 flex-1 min-w-[200px]">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              End Date
            </label>
            <input
              type="date"
              className="w-full p-2.5 text-sm text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md transition-all focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20"
              value={endDate}
              onChange={(e) => onEndDateChange(e.target.value)}
              min={minDate}
              max={maxDate}
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default DateRangeFilter;
